<script setup lang="ts">

</script>

<template>
    <v-row>           
        <v-col>
            <v-card
                class="pa-0 pb-3 mx-auto d-flex flex-column"
                width="1000"
                height="300"
            >
                <v-card-title>CSEC Subject Selection</v-card-title>

                <v-container class="d-flex flex-grow-1 align-center">
                    <v-row>
                        <v-col 
                            v-for="(item, i) in formClasses" :key="i" 
                            cols="4" class="d-flex justify-center" 
                        >
                            <v-hover>
                                <template v-slot:default=" { hover }">
                                    <v-card 
                                        outlined 
                                        style="border: 2px solid" 
                                        width="200" 
                                        height="100" 
                                        class="d-flex justify-center align-center"
                                        @click="showClass(item.id)"
                                    >
                                        <div class="text-h4">{{ item.id }}</div>
                                        <v-fade-transition>
                                            <v-overlay
                                                v-if="hover"
                                                absolute
                                                color="primary"
                                            ></v-overlay>
                                        </v-fade-transition>
                                    </v-card>
                                </template>
                            </v-hover>    
                        </v-col>
                        
                    </v-row>
                </v-container>

                <v-overlay :value="overlay" absolute>
                    <v-progress-circular 
                        indeterminate 
                        size="64"
                    ></v-progress-circular>
                </v-overlay>
            </v-card>
        </v-col>

        <v-dialog v-model="dialog" max-width="800" persistent>
            <v-card>
                <v-card-title class="d-flex align-center justify-space-between">
                    {{ formClassSelected}}
                    <v-btn
                        icon
                        @click="dialog = false"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider />

                <v-card-text>
                    <v-card flat>
                        <v-card-title>
                            Students
                            <v-spacer></v-spacer>
                            <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="Search"
                                single-line
                                hide-details
                            ></v-text-field>
                        </v-card-title>
                    </v-card>
                    <v-data-table
                        :headers="headers"
                        :items="students"
                        :loading="loading"
                        fixed-header
                        height="40vh"
                        class="elevation-0 mt-4"
                        :search="search"
                    >
                        <template v-slot:[`item.action`]="{ item }">
                            <v-btn outlined small @click="editItem(item)">
                                <v-icon
                                    small
                                    class="mr-2"
                                    
                                >
                                    mdi-pencil
                                </v-icon>
                                Edit

                            </v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
                
                <v-divider />
                
                <v-card-actions>
                    <v-spacer />
                    <v-btn depressed @click="dialog = false" class="mr-3">Close Class</v-btn>
                </v-card-actions>

                <CSECSubjectSelectionStudent
                    :studentRecord="selectedStudentRecord"
                    :display="displayStudent"
                    @close="closeStudentSelection"
                ></CSECSubjectSelectionStudent>
            </v-card>
        </v-dialog>
        
        
        
    </v-row>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import CSECSubjectSelectionStudent from './CSECSubjectSelectionStudent.vue'
export default {
    created () {
        this.initialize();    
    },

    components: {
        CSECSubjectSelectionStudent
    },

    data: function(){
        return {
            formClasses: [], 
            overlay: false,
            dialog: false,
            formClassSelected: '',  
            headers: [
                {'text': 'Student ID', 'value': 'student_id'},
                {'text': 'First Name', 'value': 'first_name'},
                {'text': 'Last Name', 'value': 'last_name'},
                {'text': 'Action', 'value': 'action'},
            ],
            students: [],
            loading: false,
            search: '',  
            selectedStudentRecord: null, 
            displayStudent: false,
        }
    },

    methods: {
        ...mapActions({
            getFormClasses: 'csecSubjectSelection/getFormClasses',
            getStudents: 'csecSubjectSelection/getStudents',
        }),

        ...mapMutations({
            setSelectedFormClass: 'csecSubjectSelection/setSelectedFormClass',
            setSelectedStudent: 'csecSubjectSelection/setSelectedStudent',
        }),

        async initialize(){
            this.overlay = true;
            try {
                const { data } = await this.getFormClasses();
                this.formClasses = data;
            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);
            } finally {
                this.overlay = false;
            }
        },

        async showClass(formClassId) {
            this.formClassSelected = formClassId;
            this.setSelectedFormClass(formClassId);
            this.dialog = true;
            this.loading = true;
            try{
                const { data } = await this.getStudents();
                this.students = data;
            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);
            } finally {
                this.loading = false;
            }
        },

        editItem (item){
            this.selectedStudentRecord = item;
            this.setSelectedStudent(item);
            this.displayStudent = true;
        },

        closeStudentSelection(){
            this.displayStudent = false;
            this.selectedStudentRecord = null;
            this.setSelectedStudent(null);
        }
    }
}
</script>

